import type {AdminAccessUxState} from "../services/types.ts";

const TITLE_KEYS: Record<Exclude<AdminAccessUxState, "admin" | "bootstrap_choice">, string> = {
    subscription_inactive: "text.subscription-inactive-title",
    member_denied: "text.member-denied-title",
    member_removed: "text.member-removed-title",
    tenant_unlinked: "text.tenant-unlinked-title",
};

const BODY_KEYS: Record<Exclude<AdminAccessUxState, "admin" | "bootstrap_choice">, string> = {
    subscription_inactive: "text.subscription-inactive",
    member_denied: "text.member-denied",
    member_removed: "text.member-removed",
    tenant_unlinked: "text.tenant-unlinked",
};

export function titleKeyFor(state: Exclude<AdminAccessUxState, "admin" | "bootstrap_choice">): string {
    return TITLE_KEYS[state];
}

export function bodyKeyFor(state: Exclude<AdminAccessUxState, "admin" | "bootstrap_choice">): string {
    return BODY_KEYS[state];
}
